module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAKCAIAAAD6sKMdAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABRJREFUeNpiOHPmDBMDAwMhDBBgAFxoAncdSp1mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/trenner_td.png
// module id = 115
// module chunks = 51